import { ReactNode } from "react";
import { HashLink } from "react-router-hash-link";

const Filtertext = ({ children }: { children: ReactNode }) => {
    return(
            <HashLink smooth to="#projects" className="hover:underline scroll-smooth">
                    {children}
            </HashLink>
    )
}

export default Filtertext;